module.exports = __webpack_public_path__ + "static/media/home_tunnel_5.6793e11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_5.png
// module id = 116
// module chunks = 0